import React, { useMemo, useState } from 'react';
import { InputGroup } from 'reactstrap';
import OpenDetailsButton from 'components/buttons/OpenDetailsButton';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import ConfirmedButton from 'components/buttons/ConfirmedButton';
import { OBJ } from 'constants';
import MediaViewer from '../common/MediaViewer';
import FileUpload from 'components/modules/uploads/FileUpload';
import ObjectSelectorDropdown from './ObjectSelectorDropdown';
import ObjectSelectorInput from './ObjectSelectorInput';
import IconButton from 'components/iconInput/IconButton';
import { NEW_ITEM_ID } from 'constants';
import { useFileUpload } from 'hooks/useFileUpload';
import { API_ENDPOINTS } from 'constants';
import IconInputSwitch from 'components/iconInput/IconInputSwitch';

const SearchOrAddUpload = ({uploadId, onFilesUpload, setSearchMode}) => {
    const fileUpload = useFileUpload(API_ENDPOINTS.UPLOADS.FILE_UPLOAD(uploadId), true);
    return <FileUpload fileUpload={fileUpload} onFilesUpload={onFilesUpload} showDragAndDropArea={true} setSearch={() => setSearchMode(prev => !prev)}/>
}

const ObjectSelector = ({ value, readOnly, onChange, obj, label, icon, linkValue }) => {
    const [searchMode, setSearchMode] = useState(false);
    const type = useMemo(() => typeof obj === 'string' ? obj : obj.type, [obj]);

    if(value) {
        return (<IconInputSwitch type='link' label={label} iconKey={icon}>
                    {type === OBJ.UPLOADS && 
                        <div>
                            <MediaViewer uploadId={value} maxHeight="128px"/>
                        </div>
                    }
                    <ObjectSelectorInput value={value} obj={obj} linkValue={linkValue}/>
                    <OpenDetailsButton id={value} obj={type} />
                    {!readOnly && (
                        <ConfirmedButton 
                            translationId='objectSelector.remove' 
                            messageTranslationKey='objectSelector.removeConfirm' 
                            onClick={() => onChange(null)} icon={faXmark} modalIcon={faCheck} 
                            type="IconOnly" color="red" size="sm"/>
                    )}
                </IconInputSwitch>
    )}

    const handleFilesUpload = (fileArray) => {
        if(fileArray?.length > 0){
            onChange(fileArray[0].id)
        }
    };
    
    if(type === OBJ.UPLOADS) {
        return searchMode ?
            <ObjectSelectorDropdown onChange={onChange} obj={obj} label={label} icon={icon} setSearchMode={() => setSearchMode(prev => !prev)}/>
        :
            <SearchOrAddUpload uploadId={NEW_ITEM_ID} onFilesUpload={handleFilesUpload} showDragAndDropArea={true} setSearchMode={() => setSearchMode(prev => !prev)}/>
    }
    
    return <ObjectSelectorDropdown onChange={onChange} obj={obj} label={label} icon={icon}/>
};

export default ObjectSelector;
